// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800;900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:wght,FILL@100..700,0..1&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Global Styles for EK Library */

/* CSS Variables - Design System */
:root {
  /* Colors */
  --primary: #3713ec;
  --primary-dark: #2a0eb5;
  --primary-light: #ebe7fd;
  --background-light: #f6f6f8;
  --background-dark: #131022;
  --surface-light: #ffffff;
  --surface-dark: #1e1b2e;
  --text-main: #121118;
  --text-sub: #686189;
  --border-color: #dddbe6;
  --slate-50: #f8fafc;
  --slate-100: #f1f5f9;
  --slate-200: #e2e8f0;
  --slate-300: #cbd5e1;
  --slate-400: #94a3b8;
  --slate-500: #64748b;
  --slate-600: #475569;
  --slate-700: #334155;
  --slate-800: #1e293b;
  --slate-900: #0f172a;
  
  /* Status Colors */
  --success-bg: #dcfce7;
  --success-text: #166534;
  --success-border: #86efac;
  --error-bg: #fee2e2;
  --error-text: #991b1b;
  --error-border: #fca5a5;
  --warning-bg: #fef3c7;
  --warning-text: #92400e;
  --warning-border: #fcd34d;
  --info-bg: #dbeafe;
  --info-text: #1e40af;
  --info-border: #93c5fd;
  --borrowed-bg: #fee2e2;
  --borrowed-text: #991b1b;
  --borrowed-border: #fca5a5;
  --available-bg: #dcfce7;
  --available-text: #166534;
  --available-border: #86efac;
  
  /* Typography */
  --font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  
  /* Border Radius */
  --radius-sm: 0.25rem;
  --radius-md: 0.5rem;
  --radius-lg: 0.75rem;
  --radius-xl: 1rem;
  --radius-2xl: 1.5rem;
  --radius-full: 9999px;
  
  /* Shadows */
  --shadow-sm: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --shadow-md: 0 4px 6px -1px rgb(0 0 0 / 0.1);
  --shadow-lg: 0 10px 15px -3px rgb(0 0 0 / 0.1);
  --shadow-xl: 0 20px 25px -5px rgb(0 0 0 / 0.1);
  
  /* Transitions */
  --transition-fast: 150ms ease;
  --transition-normal: 200ms ease;
  --transition-slow: 300ms ease;
  
  /* Spacing */
  --spacing-1: 0.25rem;
  --spacing-2: 0.5rem;
  --spacing-3: 0.75rem;
  --spacing-4: 1rem;
  --spacing-5: 1.25rem;
  --spacing-6: 1.5rem;
  --spacing-8: 2rem;
  --spacing-10: 2.5rem;
}

/* Reset & Base */
*,
*::before,
*::after {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

html {
  font-size: 16px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

body {
  font-family: var(--font-family);
  background-color: var(--background-light);
  color: var(--text-main);
  line-height: 1.5;
  min-height: 100vh;
}

#root {
  min-height: 100vh;
}

/* Typography */
h1, h2, h3, h4, h5, h6 {
  font-weight: 700;
  line-height: 1.2;
  color: var(--text-main);
}

h1 { font-size: 2.5rem; }
h2 { font-size: 2rem; }
h3 { font-size: 1.5rem; }
h4 { font-size: 1.25rem; }
h5 { font-size: 1.125rem; }
h6 { font-size: 1rem; }

p {
  margin-bottom: 1rem;
  color: var(--text-sub);
}

a {
  color: var(--primary);
  text-decoration: none;
  transition: color var(--transition-fast);
}

a:hover {
  color: var(--primary-dark);
}

/* Material Symbols */
.material-symbols-outlined {
  font-variation-settings:
    'FILL' 0,
    'wght' 400,
    'GRAD' 0,
    'opsz' 24;
  font-size: 24px;
  line-height: 1;
  display: inline-block;
  vertical-align: middle;
}

/* Buttons */
.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--spacing-2);
  padding: var(--spacing-3) var(--spacing-5);
  font-size: 0.875rem;
  font-weight: 600;
  line-height: 1.25;
  text-align: center;
  white-space: nowrap;
  border: none;
  border-radius: var(--radius-lg);
  cursor: pointer;
  transition: all var(--transition-normal);
  font-family: var(--font-family);
}

.btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.btn-primary {
  background-color: var(--primary);
  color: white;
  box-shadow: var(--shadow-md);
}

.btn-primary:hover:not(:disabled) {
  background-color: var(--primary-dark);
  box-shadow: var(--shadow-lg);
}

.btn-primary:active:not(:disabled) {
  transform: scale(0.98);
}

.btn-secondary {
  background-color: var(--surface-light);
  color: var(--text-sub);
  border: 1px solid var(--border-color);
}

.btn-secondary:hover:not(:disabled) {
  background-color: var(--slate-50);
  color: var(--text-main);
}

.btn-danger {
  background-color: var(--error-bg);
  color: var(--error-text);
}

.btn-danger:hover:not(:disabled) {
  background-color: var(--error-text);
  color: white;
}

.btn-success {
  background-color: var(--success-bg);
  color: var(--success-text);
}

.btn-success:hover:not(:disabled) {
  background-color: var(--success-text);
  color: white;
}

.btn-outline {
  background-color: transparent;
  color: var(--primary);
  border: 1px solid var(--primary);
}

.btn-outline:hover:not(:disabled) {
  background-color: var(--primary);
  color: white;
}

.btn-ghost {
  background-color: transparent;
  color: var(--text-sub);
}

.btn-ghost:hover:not(:disabled) {
  background-color: var(--slate-100);
  color: var(--text-main);
}

.btn-sm {
  padding: var(--spacing-2) var(--spacing-3);
  font-size: 0.75rem;
}

.btn-lg {
  padding: var(--spacing-4) var(--spacing-6);
  font-size: 1rem;
}

/* Form Elements */
.form-input,
.form-select,
.form-textarea {
  display: block;
  width: 100%;
  padding: var(--spacing-3) var(--spacing-4);
  font-size: 0.875rem;
  font-family: var(--font-family);
  font-weight: 400;
  line-height: 1.5;
  color: var(--text-main);
  background-color: var(--surface-light);
  border: 1px solid var(--slate-200);
  border-radius: var(--radius-lg);
  transition: all var(--transition-fast);
}

.form-input:focus,
.form-select:focus,
.form-textarea:focus {
  outline: none;
  border-color: var(--primary);
  box-shadow: 0 0 0 3px var(--primary-light);
}

.form-input::placeholder {
  color: var(--slate-400);
}

.form-textarea {
  resize: vertical;
  min-height: 100px;
}

.form-label {
  display: block;
  margin-bottom: var(--spacing-2);
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--text-main);
}

.form-group {
  margin-bottom: var(--spacing-5);
}

/* Cards */
.card {
  background-color: var(--surface-light);
  border-radius: var(--radius-xl);
  border: 1px solid var(--slate-200);
  box-shadow: var(--shadow-sm);
  overflow: hidden;
}

.card-header {
  padding: var(--spacing-5) var(--spacing-6);
  border-bottom: 1px solid var(--slate-200);
  background-color: var(--slate-50);
}

.card-title {
  font-size: 1.125rem;
  font-weight: 600;
  color: var(--text-main);
}

.card-body {
  padding: var(--spacing-6);
}

/* Badges */
.badge {
  display: inline-flex;
  align-items: center;
  gap: var(--spacing-1);
  padding: var(--spacing-1) var(--spacing-3);
  font-size: 0.75rem;
  font-weight: 600;
  line-height: 1.25;
  border-radius: var(--radius-full);
  white-space: nowrap;
}

.badge-available,
.badge-returned {
  background-color: var(--available-bg);
  color: var(--available-text);
}

.badge-borrowed {
  background-color: var(--borrowed-bg);
  color: var(--borrowed-text);
}

.badge-lost {
  background-color: var(--slate-200);
  color: var(--slate-600);
}

.badge-primary {
  background-color: var(--primary-light);
  color: var(--primary);
}

.badge-secondary {
  background-color: var(--slate-100);
  color: var(--slate-600);
}

/* Tables */
.table-container {
  overflow-x: auto;
}

.table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.875rem;
}

.table thead {
  background-color: var(--slate-50);
  border-bottom: 1px solid var(--slate-200);
}

.table th {
  padding: var(--spacing-4) var(--spacing-6);
  text-align: left;
  font-weight: 600;
  color: var(--text-sub);
  text-transform: uppercase;
  font-size: 0.75rem;
  letter-spacing: 0.05em;
}

.table td {
  padding: var(--spacing-4) var(--spacing-6);
  border-top: 1px solid var(--slate-200);
  color: var(--text-main);
}

.table tbody tr {
  transition: background-color var(--transition-fast);
}

.table tbody tr:hover {
  background-color: var(--slate-50);
}

.table .empty-state {
  text-align: center;
  padding: var(--spacing-10);
  color: var(--text-sub);
}

/* Loading States */
.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: var(--spacing-10);
  gap: var(--spacing-4);
}

.spinner {
  width: 40px;
  height: 40px;
  border: 3px solid var(--slate-200);
  border-top-color: var(--primary);
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

/* Modals */
.modal-overlay {
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: var(--spacing-4);
  backdrop-filter: blur(4px);
}

.modal-content {
  background-color: var(--surface-light);
  border-radius: var(--radius-xl);
  box-shadow: var(--shadow-xl);
  max-width: 1000px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
}

.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--spacing-5) var(--spacing-6);
  border-bottom: 1px solid var(--slate-200);
}

.modal-title {
  font-size: 1.25rem;
  font-weight: 700;
  color: var(--text-main);
}

.modal-close {
  background: none;
  border: none;
  cursor: pointer;
  color: var(--text-sub);
  padding: var(--spacing-2);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: var(--radius-md);
  transition: all var(--transition-fast);
}

.modal-close:hover {
  background-color: var(--slate-100);
  color: var(--text-main);
}

.modal-body {
  padding: var(--spacing-6);
}

.modal-actions {
  display: flex;
  gap: var(--spacing-3);
  justify-content: flex-end;
  padding: var(--spacing-5) var(--spacing-6);
  border-top: 1px solid var(--slate-200);
}

/* Alerts */
.alert {
  padding: var(--spacing-4);
  border-radius: var(--radius-lg);
  margin-bottom: var(--spacing-4);
  font-size: 0.875rem;
}

.alert-error {
  background-color: var(--error-bg);
  color: var(--error-text);
  border: 1px solid var(--error-border);
}

.alert-success {
  background-color: var(--success-bg);
  color: var(--success-text);
  border: 1px solid var(--success-border);
}

.alert-warning {
  background-color: var(--warning-bg);
  color: var(--warning-text);
  border: 1px solid var(--warning-border);
}

/* Utility Classes */
.flex { display: flex; }
.flex-col { flex-direction: column; }
.items-center { align-items: center; }
.justify-center { justify-content: center; }
.justify-between { justify-content: space-between; }
.gap-2 { gap: var(--spacing-2); }
.gap-3 { gap: var(--spacing-3); }
.gap-4 { gap: var(--spacing-4); }
.gap-6 { gap: var(--spacing-6); }
.mt-4 { margin-top: var(--spacing-4); }
.mt-6 { margin-top: var(--spacing-6); }
.mb-4 { margin-bottom: var(--spacing-4); }
.mb-6 { margin-bottom: var(--spacing-6); }
.text-center { text-align: center; }
.text-sm { font-size: 0.875rem; }
.text-xs { font-size: 0.75rem; }
.font-medium { font-weight: 500; }
.font-semibold { font-weight: 600; }
.font-bold { font-weight: 700; }
.text-primary { color: var(--primary); }
.text-sub { color: var(--text-sub); }
.hidden { display: none; }

/* Responsive */
@media (max-width: 768px) {
  h1 { font-size: 2rem; }
  h2 { font-size: 1.5rem; }
  h3 { font-size: 1.25rem; }
  
  .btn {
    padding: var(--spacing-2) var(--spacing-4);
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/global.css"],"names":[],"mappings":"AAAA,iCAAiC;;AAIjC,kCAAkC;AAClC;EACE,WAAW;EACX,kBAAkB;EAClB,uBAAuB;EACvB,wBAAwB;EACxB,2BAA2B;EAC3B,0BAA0B;EAC1B,wBAAwB;EACxB,uBAAuB;EACvB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;;EAEpB,kBAAkB;EAClB,qBAAqB;EACrB,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;EACnB,qBAAqB;EACrB,uBAAuB;EACvB,qBAAqB;EACrB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;EACpB,sBAAsB;EACtB,sBAAsB;EACtB,wBAAwB;EACxB,0BAA0B;EAC1B,uBAAuB;EACvB,yBAAyB;EACzB,2BAA2B;;EAE3B,eAAe;EACf,yFAAyF;;EAEzF,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,oBAAoB;EACpB,iBAAiB;EACjB,oBAAoB;EACpB,qBAAqB;;EAErB,YAAY;EACZ,0CAA0C;EAC1C,4CAA4C;EAC5C,8CAA8C;EAC9C,8CAA8C;;EAE9C,gBAAgB;EAChB,6BAA6B;EAC7B,+BAA+B;EAC/B,6BAA6B;;EAE7B,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,oBAAoB;EACpB,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA,iBAAiB;AACjB;;;EAGE,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,+BAA+B;EAC/B,yCAAyC;EACzC,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,eAAe;AACf;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,KAAK,iBAAiB,EAAE;AACxB,KAAK,eAAe,EAAE;AACtB,KAAK,iBAAiB,EAAE;AACxB,KAAK,kBAAkB,EAAE;AACzB,KAAK,mBAAmB,EAAE;AAC1B,KAAK,eAAe,EAAE;;AAEtB;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,wCAAwC;AAC1C;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,qBAAqB;AACrB;EACE;;;;aAIW;EACX,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA,YAAY;AACZ;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,0CAA0C;EAC1C,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,+BAA+B;EAC/B,eAAe;EACf,wCAAwC;EACxC,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,qCAAqC;EACrC,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sCAAsC;EACtC,sBAAsB;EACtB,qCAAqC;AACvC;;AAEA;EACE,iCAAiC;EACjC,uBAAuB;AACzB;;AAEA;EACE,iCAAiC;EACjC,wBAAwB;AAC1B;;AAEA;EACE,mCAAmC;EACnC,YAAY;AACd;;AAEA;EACE,mCAAmC;EACnC,0BAA0B;AAC5B;;AAEA;EACE,qCAAqC;EACrC,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;EAClC,uBAAuB;AACzB;;AAEA;EACE,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;EACE,0CAA0C;EAC1C,eAAe;AACjB;;AAEA,kBAAkB;AAClB;;;EAGE,cAAc;EACd,WAAW;EACX,0CAA0C;EAC1C,mBAAmB;EACnB,+BAA+B;EAC/B,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,sCAAsC;EACtC,kCAAkC;EAClC,+BAA+B;EAC/B,sCAAsC;AACxC;;AAEA;;;EAGE,aAAa;EACb,4BAA4B;EAC5B,0CAA0C;AAC5C;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,+BAA+B;AACjC;;AAEA,UAAU;AACV;EACE,sCAAsC;EACtC,+BAA+B;EAC/B,kCAAkC;EAClC,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;EAC1C,yCAAyC;EACzC,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,WAAW;AACX;EACE,oBAAoB;EACpB,mBAAmB;EACnB,qBAAqB;EACrB,0CAA0C;EAC1C,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;;EAEE,qCAAqC;EACrC,4BAA4B;AAC9B;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,kCAAkC;EAClC,uBAAuB;AACzB;;AAEA;EACE,sCAAsC;EACtC,qBAAqB;AACvB;;AAEA;EACE,kCAAkC;EAClC,uBAAuB;AACzB;;AAEA,WAAW;AACX;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,yCAAyC;AAC3C;;AAEA;EACE,0CAA0C;EAC1C,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,0CAA0C;EAC1C,sCAAsC;EACtC,uBAAuB;AACzB;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,gCAAgC;EAChC,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA,WAAW;AACX;EACE,eAAe;EACf,QAAQ;EACR,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,sCAAsC;EACtC,+BAA+B;EAC/B,4BAA4B;EAC5B,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,0CAA0C;EAC1C,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,sCAAsC;AACxC;;AAEA;EACE,kCAAkC;EAClC,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,yBAAyB;EACzB,0CAA0C;EAC1C,sCAAsC;AACxC;;AAEA,WAAW;AACX;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,wBAAwB;EACxB,qCAAqC;AACvC;;AAEA;EACE,mCAAmC;EACnC,0BAA0B;EAC1B,uCAAuC;AACzC;;AAEA;EACE,mCAAmC;EACnC,0BAA0B;EAC1B,uCAAuC;AACzC;;AAEA,oBAAoB;AACpB,QAAQ,aAAa,EAAE;AACvB,YAAY,sBAAsB,EAAE;AACpC,gBAAgB,mBAAmB,EAAE;AACrC,kBAAkB,uBAAuB,EAAE;AAC3C,mBAAmB,8BAA8B,EAAE;AACnD,SAAS,qBAAqB,EAAE;AAChC,SAAS,qBAAqB,EAAE;AAChC,SAAS,qBAAqB,EAAE;AAChC,SAAS,qBAAqB,EAAE;AAChC,QAAQ,4BAA4B,EAAE;AACtC,QAAQ,4BAA4B,EAAE;AACtC,QAAQ,+BAA+B,EAAE;AACzC,QAAQ,+BAA+B,EAAE;AACzC,eAAe,kBAAkB,EAAE;AACnC,WAAW,mBAAmB,EAAE;AAChC,WAAW,kBAAkB,EAAE;AAC/B,eAAe,gBAAgB,EAAE;AACjC,iBAAiB,gBAAgB,EAAE;AACnC,aAAa,gBAAgB,EAAE;AAC/B,gBAAgB,qBAAqB,EAAE;AACvC,YAAY,sBAAsB,EAAE;AACpC,UAAU,aAAa,EAAE;;AAEzB,eAAe;AACf;EACE,KAAK,eAAe,EAAE;EACtB,KAAK,iBAAiB,EAAE;EACxB,KAAK,kBAAkB,EAAE;;EAEzB;IACE,0CAA0C;EAC5C;AACF","sourcesContent":["/* Global Styles for EK Library */\n@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800;900&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:wght,FILL@100..700,0..1&display=swap');\n\n/* CSS Variables - Design System */\n:root {\n  /* Colors */\n  --primary: #3713ec;\n  --primary-dark: #2a0eb5;\n  --primary-light: #ebe7fd;\n  --background-light: #f6f6f8;\n  --background-dark: #131022;\n  --surface-light: #ffffff;\n  --surface-dark: #1e1b2e;\n  --text-main: #121118;\n  --text-sub: #686189;\n  --border-color: #dddbe6;\n  --slate-50: #f8fafc;\n  --slate-100: #f1f5f9;\n  --slate-200: #e2e8f0;\n  --slate-300: #cbd5e1;\n  --slate-400: #94a3b8;\n  --slate-500: #64748b;\n  --slate-600: #475569;\n  --slate-700: #334155;\n  --slate-800: #1e293b;\n  --slate-900: #0f172a;\n  \n  /* Status Colors */\n  --success-bg: #dcfce7;\n  --success-text: #166534;\n  --success-border: #86efac;\n  --error-bg: #fee2e2;\n  --error-text: #991b1b;\n  --error-border: #fca5a5;\n  --warning-bg: #fef3c7;\n  --warning-text: #92400e;\n  --warning-border: #fcd34d;\n  --info-bg: #dbeafe;\n  --info-text: #1e40af;\n  --info-border: #93c5fd;\n  --borrowed-bg: #fee2e2;\n  --borrowed-text: #991b1b;\n  --borrowed-border: #fca5a5;\n  --available-bg: #dcfce7;\n  --available-text: #166534;\n  --available-border: #86efac;\n  \n  /* Typography */\n  --font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  \n  /* Border Radius */\n  --radius-sm: 0.25rem;\n  --radius-md: 0.5rem;\n  --radius-lg: 0.75rem;\n  --radius-xl: 1rem;\n  --radius-2xl: 1.5rem;\n  --radius-full: 9999px;\n  \n  /* Shadows */\n  --shadow-sm: 0 1px 2px 0 rgb(0 0 0 / 0.05);\n  --shadow-md: 0 4px 6px -1px rgb(0 0 0 / 0.1);\n  --shadow-lg: 0 10px 15px -3px rgb(0 0 0 / 0.1);\n  --shadow-xl: 0 20px 25px -5px rgb(0 0 0 / 0.1);\n  \n  /* Transitions */\n  --transition-fast: 150ms ease;\n  --transition-normal: 200ms ease;\n  --transition-slow: 300ms ease;\n  \n  /* Spacing */\n  --spacing-1: 0.25rem;\n  --spacing-2: 0.5rem;\n  --spacing-3: 0.75rem;\n  --spacing-4: 1rem;\n  --spacing-5: 1.25rem;\n  --spacing-6: 1.5rem;\n  --spacing-8: 2rem;\n  --spacing-10: 2.5rem;\n}\n\n/* Reset & Base */\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n}\n\nhtml {\n  font-size: 16px;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\nbody {\n  font-family: var(--font-family);\n  background-color: var(--background-light);\n  color: var(--text-main);\n  line-height: 1.5;\n  min-height: 100vh;\n}\n\n#root {\n  min-height: 100vh;\n}\n\n/* Typography */\nh1, h2, h3, h4, h5, h6 {\n  font-weight: 700;\n  line-height: 1.2;\n  color: var(--text-main);\n}\n\nh1 { font-size: 2.5rem; }\nh2 { font-size: 2rem; }\nh3 { font-size: 1.5rem; }\nh4 { font-size: 1.25rem; }\nh5 { font-size: 1.125rem; }\nh6 { font-size: 1rem; }\n\np {\n  margin-bottom: 1rem;\n  color: var(--text-sub);\n}\n\na {\n  color: var(--primary);\n  text-decoration: none;\n  transition: color var(--transition-fast);\n}\n\na:hover {\n  color: var(--primary-dark);\n}\n\n/* Material Symbols */\n.material-symbols-outlined {\n  font-variation-settings:\n    'FILL' 0,\n    'wght' 400,\n    'GRAD' 0,\n    'opsz' 24;\n  font-size: 24px;\n  line-height: 1;\n  display: inline-block;\n  vertical-align: middle;\n}\n\n/* Buttons */\n.btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: var(--spacing-2);\n  padding: var(--spacing-3) var(--spacing-5);\n  font-size: 0.875rem;\n  font-weight: 600;\n  line-height: 1.25;\n  text-align: center;\n  white-space: nowrap;\n  border: none;\n  border-radius: var(--radius-lg);\n  cursor: pointer;\n  transition: all var(--transition-normal);\n  font-family: var(--font-family);\n}\n\n.btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.btn-primary {\n  background-color: var(--primary);\n  color: white;\n  box-shadow: var(--shadow-md);\n}\n\n.btn-primary:hover:not(:disabled) {\n  background-color: var(--primary-dark);\n  box-shadow: var(--shadow-lg);\n}\n\n.btn-primary:active:not(:disabled) {\n  transform: scale(0.98);\n}\n\n.btn-secondary {\n  background-color: var(--surface-light);\n  color: var(--text-sub);\n  border: 1px solid var(--border-color);\n}\n\n.btn-secondary:hover:not(:disabled) {\n  background-color: var(--slate-50);\n  color: var(--text-main);\n}\n\n.btn-danger {\n  background-color: var(--error-bg);\n  color: var(--error-text);\n}\n\n.btn-danger:hover:not(:disabled) {\n  background-color: var(--error-text);\n  color: white;\n}\n\n.btn-success {\n  background-color: var(--success-bg);\n  color: var(--success-text);\n}\n\n.btn-success:hover:not(:disabled) {\n  background-color: var(--success-text);\n  color: white;\n}\n\n.btn-outline {\n  background-color: transparent;\n  color: var(--primary);\n  border: 1px solid var(--primary);\n}\n\n.btn-outline:hover:not(:disabled) {\n  background-color: var(--primary);\n  color: white;\n}\n\n.btn-ghost {\n  background-color: transparent;\n  color: var(--text-sub);\n}\n\n.btn-ghost:hover:not(:disabled) {\n  background-color: var(--slate-100);\n  color: var(--text-main);\n}\n\n.btn-sm {\n  padding: var(--spacing-2) var(--spacing-3);\n  font-size: 0.75rem;\n}\n\n.btn-lg {\n  padding: var(--spacing-4) var(--spacing-6);\n  font-size: 1rem;\n}\n\n/* Form Elements */\n.form-input,\n.form-select,\n.form-textarea {\n  display: block;\n  width: 100%;\n  padding: var(--spacing-3) var(--spacing-4);\n  font-size: 0.875rem;\n  font-family: var(--font-family);\n  font-weight: 400;\n  line-height: 1.5;\n  color: var(--text-main);\n  background-color: var(--surface-light);\n  border: 1px solid var(--slate-200);\n  border-radius: var(--radius-lg);\n  transition: all var(--transition-fast);\n}\n\n.form-input:focus,\n.form-select:focus,\n.form-textarea:focus {\n  outline: none;\n  border-color: var(--primary);\n  box-shadow: 0 0 0 3px var(--primary-light);\n}\n\n.form-input::placeholder {\n  color: var(--slate-400);\n}\n\n.form-textarea {\n  resize: vertical;\n  min-height: 100px;\n}\n\n.form-label {\n  display: block;\n  margin-bottom: var(--spacing-2);\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: var(--text-main);\n}\n\n.form-group {\n  margin-bottom: var(--spacing-5);\n}\n\n/* Cards */\n.card {\n  background-color: var(--surface-light);\n  border-radius: var(--radius-xl);\n  border: 1px solid var(--slate-200);\n  box-shadow: var(--shadow-sm);\n  overflow: hidden;\n}\n\n.card-header {\n  padding: var(--spacing-5) var(--spacing-6);\n  border-bottom: 1px solid var(--slate-200);\n  background-color: var(--slate-50);\n}\n\n.card-title {\n  font-size: 1.125rem;\n  font-weight: 600;\n  color: var(--text-main);\n}\n\n.card-body {\n  padding: var(--spacing-6);\n}\n\n/* Badges */\n.badge {\n  display: inline-flex;\n  align-items: center;\n  gap: var(--spacing-1);\n  padding: var(--spacing-1) var(--spacing-3);\n  font-size: 0.75rem;\n  font-weight: 600;\n  line-height: 1.25;\n  border-radius: var(--radius-full);\n  white-space: nowrap;\n}\n\n.badge-available,\n.badge-returned {\n  background-color: var(--available-bg);\n  color: var(--available-text);\n}\n\n.badge-borrowed {\n  background-color: var(--borrowed-bg);\n  color: var(--borrowed-text);\n}\n\n.badge-lost {\n  background-color: var(--slate-200);\n  color: var(--slate-600);\n}\n\n.badge-primary {\n  background-color: var(--primary-light);\n  color: var(--primary);\n}\n\n.badge-secondary {\n  background-color: var(--slate-100);\n  color: var(--slate-600);\n}\n\n/* Tables */\n.table-container {\n  overflow-x: auto;\n}\n\n.table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.875rem;\n}\n\n.table thead {\n  background-color: var(--slate-50);\n  border-bottom: 1px solid var(--slate-200);\n}\n\n.table th {\n  padding: var(--spacing-4) var(--spacing-6);\n  text-align: left;\n  font-weight: 600;\n  color: var(--text-sub);\n  text-transform: uppercase;\n  font-size: 0.75rem;\n  letter-spacing: 0.05em;\n}\n\n.table td {\n  padding: var(--spacing-4) var(--spacing-6);\n  border-top: 1px solid var(--slate-200);\n  color: var(--text-main);\n}\n\n.table tbody tr {\n  transition: background-color var(--transition-fast);\n}\n\n.table tbody tr:hover {\n  background-color: var(--slate-50);\n}\n\n.table .empty-state {\n  text-align: center;\n  padding: var(--spacing-10);\n  color: var(--text-sub);\n}\n\n/* Loading States */\n.loading-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: var(--spacing-10);\n  gap: var(--spacing-4);\n}\n\n.spinner {\n  width: 40px;\n  height: 40px;\n  border: 3px solid var(--slate-200);\n  border-top-color: var(--primary);\n  border-radius: 50%;\n  animation: spin 0.8s linear infinite;\n}\n\n@keyframes spin {\n  to { transform: rotate(360deg); }\n}\n\n/* Modals */\n.modal-overlay {\n  position: fixed;\n  inset: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: var(--spacing-4);\n  backdrop-filter: blur(4px);\n}\n\n.modal-content {\n  background-color: var(--surface-light);\n  border-radius: var(--radius-xl);\n  box-shadow: var(--shadow-xl);\n  max-width: 1000px;\n  width: 100%;\n  max-height: 90vh;\n  overflow-y: auto;\n}\n\n.modal-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: var(--spacing-5) var(--spacing-6);\n  border-bottom: 1px solid var(--slate-200);\n}\n\n.modal-title {\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: var(--text-main);\n}\n\n.modal-close {\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: var(--text-sub);\n  padding: var(--spacing-2);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: var(--radius-md);\n  transition: all var(--transition-fast);\n}\n\n.modal-close:hover {\n  background-color: var(--slate-100);\n  color: var(--text-main);\n}\n\n.modal-body {\n  padding: var(--spacing-6);\n}\n\n.modal-actions {\n  display: flex;\n  gap: var(--spacing-3);\n  justify-content: flex-end;\n  padding: var(--spacing-5) var(--spacing-6);\n  border-top: 1px solid var(--slate-200);\n}\n\n/* Alerts */\n.alert {\n  padding: var(--spacing-4);\n  border-radius: var(--radius-lg);\n  margin-bottom: var(--spacing-4);\n  font-size: 0.875rem;\n}\n\n.alert-error {\n  background-color: var(--error-bg);\n  color: var(--error-text);\n  border: 1px solid var(--error-border);\n}\n\n.alert-success {\n  background-color: var(--success-bg);\n  color: var(--success-text);\n  border: 1px solid var(--success-border);\n}\n\n.alert-warning {\n  background-color: var(--warning-bg);\n  color: var(--warning-text);\n  border: 1px solid var(--warning-border);\n}\n\n/* Utility Classes */\n.flex { display: flex; }\n.flex-col { flex-direction: column; }\n.items-center { align-items: center; }\n.justify-center { justify-content: center; }\n.justify-between { justify-content: space-between; }\n.gap-2 { gap: var(--spacing-2); }\n.gap-3 { gap: var(--spacing-3); }\n.gap-4 { gap: var(--spacing-4); }\n.gap-6 { gap: var(--spacing-6); }\n.mt-4 { margin-top: var(--spacing-4); }\n.mt-6 { margin-top: var(--spacing-6); }\n.mb-4 { margin-bottom: var(--spacing-4); }\n.mb-6 { margin-bottom: var(--spacing-6); }\n.text-center { text-align: center; }\n.text-sm { font-size: 0.875rem; }\n.text-xs { font-size: 0.75rem; }\n.font-medium { font-weight: 500; }\n.font-semibold { font-weight: 600; }\n.font-bold { font-weight: 700; }\n.text-primary { color: var(--primary); }\n.text-sub { color: var(--text-sub); }\n.hidden { display: none; }\n\n/* Responsive */\n@media (max-width: 768px) {\n  h1 { font-size: 2rem; }\n  h2 { font-size: 1.5rem; }\n  h3 { font-size: 1.25rem; }\n  \n  .btn {\n    padding: var(--spacing-2) var(--spacing-4);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
